/* eslint-disable @typescript-eslint/prefer-readonly-parameter-types */
/* eslint-disable functional/no-conditional-statement */
import { useEffect, useRef } from "react";

// For keyboard accessibility with anchor element having no href
export function useOnElementClickRef<T extends HTMLElement>() {
  const ref = useRef<T>(null);

  const onEnterKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Enter") {
      (event.target as HTMLElement).click();
      event.preventDefault();
    }
  };

  useEffect(() => {
    ref.current?.addEventListener("keydown", onEnterKeyDown);

    return () => ref.current?.removeEventListener("keydown", onEnterKeyDown);
  }, [ref.current]);
  return ref;
}
